<template>
  <div id="vue-search-app">
    <keep-alive>
      <AppQuickSearch></AppQuickSearch>
    </keep-alive>

  </div><!-- #vue-search-app -->
</template>
<script>
import AppQuickSearch from './components/AppQuickSearch';

export default {
  components: {
    AppQuickSearch
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue